<svg-icon class="icon-confirmed" src="/assets/icons/checkmark-empty-circle.svg"></svg-icon>
<h1 class="title">Order Confirmed</h1>
<div class="order-details" *ngIf="workbookBloc.workbookCandidate$ | async as candidate">
  <div class="details">
    <h3 class="detail-title">Shipping Address</h3>
    <p class="information">{{ candidate.firstName }} {{ candidate.lastName }}</p>
    <p class="information">{{ candidate.addressLine }}</p>
    <p class="information">{{ candidate.city }}, {{ candidate.region }} {{ candidate.postalCode }}</p>
  </div>
  <div class="details">
    <h3 class="detail-title">Email Address</h3>
    <p class="information">{{ candidate.email }}</p>
    <h3 class="detail-title">Purposeful Workbook</h3>
    <p class="information">Ordered {{ date }}</p>
    <p class="information">Arrives 3-5 weeks from order</p>
  </div>
</div>
<a
  class="button button-pill button-continue"
  [routerLink]="continueLink"
  [queryParams]="{ verificationLink: candidate?.eligibilityLink }">
  Continue
</a>
<!-- Using prettier ignore comment here to keep the period aligned with the end of the sentence without a space -->
<!-- prettier-ignore -->
<p class="help-text">
  If you have any questions regarding your order, please contact us at
  <a class="email-link" href="mailto:support@kumanu.com?subject=Workbook Order Question">support@kumanu.com</a>.
</p>
